/**
 * Modal wiring for snippets/modal.liquid.
 *
 * The heavy lifting is the native <dialog> element's: showModal() traps focus, makes the
 * rest of the page inert, handles Esc, and paints ::backdrop. This only connects the
 * triggers and adds the two conveniences <dialog> does not provide — closing on a
 * backdrop click, and locking background scroll while open.
 *
 * Delegated from the document so modals rendered later (or re-rendered by a section)
 * keep working without re-binding.
 */

// Wrapped so nothing here reaches global scope: these are classic scripts, and a
// top-level name shared with another file makes the whole file throw before it can
// register its element. Also what makes a duplicate <script> tag for this file safe.
(() => {
  const SCROLL_LOCK = 'overflow-hidden';

  document.addEventListener('click', (event) => {
    /* ---- Open ---- */
    const trigger = event.target.closest('[data-modal-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.modalOpen);
      if (dialog?.showModal) {
        event.preventDefault();
        dialog.showModal();
        document.body.classList.add(SCROLL_LOCK);
      }
      return;
    }

    /* ---- Close button ---- */
    const closer = event.target.closest('[data-modal-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    /* ---- Backdrop ---- */
    // A click on the dialog element itself (rather than its panel) is the backdrop:
    // the panel covers the dialog's whole content box, so anything outside it is chrome.
    const dialog = event.target.closest('dialog.modal');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });

  // `close` fires however it was dismissed — button, backdrop or Esc — so the scroll lock
  // is released in exactly one place.
  document.addEventListener(
    'close',
    (event) => {
      if (event.target.matches?.('dialog.modal')) {
        document.body.classList.remove(SCROLL_LOCK);
      }
    },
    true
  );
})();
